"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavTabPopup = exports.NavTabLink = exports.NavTab = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _DropDown = _interopRequireDefault(require("../DropDown"));

var _dropDown = _interopRequireDefault(require("../icons/drop-down.svg"));

require("./navTabs.sass");

var NavTab = function NavTab(_ref) {
  var className = _ref.className,
      active = _ref.active,
      Icon = _ref.Icon,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "active", "Icon", "children"]);
  Icon = Icon ? _react.default.createElement(Icon, {
    className: "tab-icon"
  }) : null;
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)('tab', className, {
      'tab--active': active,
      'tab--hasIcon': !!Icon
    })
  }, props), Icon, children);
};

exports.NavTab = NavTab;
NavTab.propTypes = process.env.NODE_ENV !== "production" ? {
  active: _propTypes.default.bool,
  className: _propTypes.default.any,
  Icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.Component)])
} : {};

var NavTabLink = function NavTabLink(_ref2) {
  var to = _ref2.to,
      exact = _ref2.exact,
      className = _ref2.className,
      Icon = _ref2.Icon,
      children = _ref2.children,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["to", "exact", "className", "Icon", "children"]);
  Icon = Icon ? _react.default.createElement(Icon, {
    className: "tab-icon"
  }) : null;
  return _react.default.createElement(_reactRouterDom.Route, {
    path: to,
    exact: exact
  }, function (_ref3) {
    var match = _ref3.match;
    return _react.default.createElement(_reactRouterDom.Link, (0, _extends2.default)({
      to: to,
      className: (0, _classnames.default)('tab', className, {
        'tab--active': !!match,
        'tab--hasIcon': !!Icon
      })
    }, props), Icon, children);
  });
};

exports.NavTabLink = NavTabLink;
NavTabLink.propTypes = process.env.NODE_ENV !== "production" ? {
  to: _propTypes.default.string,
  exact: _propTypes.default.bool,
  className: _propTypes.default.any,
  Icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.Component)])
} : {};

var _ref5 = _react.default.createElement(_dropDown.default, {
  className: "tab-service-icon"
});

var NavTabPopup =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(NavTabPopup, _PureComponent);

  function NavTabPopup() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, NavTabPopup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(NavTabPopup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onClick", function () {
      _this.setState(function (_ref4) {
        var active = _ref4.active;
        return {
          active: !active
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(NavTabPopup, [{
    key: "render",
    value: function render() {
      var trigger = _react.default.createElement(NavTab, {
        Icon: this.props.Icon
      }, this.props.label, _ref5);

      return _react.default.createElement(_DropDown.default, {
        trigger: trigger
      }, this.props.children);
    }
  }]);
  return NavTabPopup;
}(_react.PureComponent);

exports.NavTabPopup = NavTabPopup;
NavTabPopup.propTypes = process.env.NODE_ENV !== "production" ? {
  label: _propTypes.default.node,
  Icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(_react.Component)])
} : {};

var NavTabs = function NavTabs(_ref6) {
  var className = _ref6.className,
      onRef = _ref6.onRef,
      stretch = _ref6.stretch,
      props = (0, _objectWithoutProperties2.default)(_ref6, ["className", "onRef", "stretch"]);
  return _react.default.createElement("nav", (0, _extends2.default)({
    ref: onRef,
    className: (0, _classnames.default)('tabs', {
      'tabs--stretch': stretch
    }, className)
  }, props));
};

NavTabs.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.any,
  stretch: _propTypes.default.bool
} : {};
var _default = NavTabs;
exports.default = _default;